import { Component, OnInit, OnChanges, SimpleChanges, Input, ViewChild, ElementRef } from '@angular/core';
import { SellerApiService } from '../../service/seller-api.service';
import { finalize } from 'rxjs/operators';
import { GlobalEventsManager } from '../../../app-global-events-manager';
// jQuery Sign $
declare let $: any;

@Component({
  selector: 'app-common',
  templateUrl: './common.component.html',
  styleUrls: ['./common.component.scss']
})
export class CommonComponent implements OnInit, OnChanges  {

  @Input() projectId: number;
  @Input() buyerId: number;
  @Input() currentUserId: number;
  @Input() currentSellerId: number;
  @Input() brief: boolean;
  @Input() details: boolean;
  @Input() safetyAttach: boolean;
  @Input() browseAttach: boolean;
  @Input() isedit: boolean;
  @Input() displaycomname: string;
  @Input() formone: Array<any>;
  @Input() commonlistObj: any;

  isbreif: boolean;
  isDetails: boolean;
  isSafetyAttach: boolean;
  isBrowseAttach: boolean;
  isEditable: boolean;
  isVisibleEdit: boolean;
  displaycomponent: string;
  isuploadImages: boolean;
  buyer_id: number;
  uploaded_links: Array<any> = [];
  @ViewChild('commonscopecomponent') commonscopecomponent;
  @ViewChild('commondetailscomponent') commondetailscomponent;
  @ViewChild('commonsafetyboxbrowse') commonsafetyboxbrowse;
  @ViewChild('saveConfirmationModal') saveConfirmationModal: ElementRef;
  questionResponseObject: any;

  commonListObject: any = {
    formone: [],
    formtwo: [],
    questionset: []

  };
  commonObject: any = {
    project_name: null,
    sub_category_position: null,
    scope_upload_links: []
  };
  commonDisableObject: any = {};
  loadingActive: boolean;
  constructor(private sellerService: SellerApiService, private _globalEvent: GlobalEventsManager) {
    this._globalEvent.sendopenConfirmationModalEmitter.subscribe((mode) => {
      if (mode && this.isEditable) {
         this.callModaltoOpen();
      }
    });
   }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    this.displaycomponent = this.displaycomname;
    this.isDetails = this.details;
    this.isbreif = this.brief;
    this.isSafetyAttach = this.safetyAttach;
    this.isBrowseAttach = this.browseAttach;
    this.isVisibleEdit = this.isedit;
    this.buyer_id = this.buyerId;
    this.isEditable = false;
    if (this.projectId != null && this.currentUserId != null) {
      this.getQuestionSetByProjectId(this.projectId );
      this.getServiceRequestByprojectId(this.projectId, this.currentUserId);
    }

  }


  getQuestionSetByProjectId(projectId) {
    // this.loaderActivate = true;
    this.sellerService.getServiceRequestQuestionSetByProjectId(projectId).pipe(finalize(() => {
      // this.loaderActivate = false;
    })).subscribe(response => {
      this.commonListObject = JSON.parse(response.question_set);
    }, err => {
      console.log(err);
    });
  }

    // Get the Project Information using projectID and Seller User Id. (Categories Scope and Details )
    getServiceRequestByprojectId(project_id, user_id) {
      this.uploaded_links = [];
      this.sellerService.getServiceRequestDetailsByProjectId(project_id, user_id).subscribe(res => {
        if (res != null) {
          this.commonObject = this.toConvertToObject(res);
          if (typeof this.commonObject.scope_upload_links !== 'undefined') {
            if (Array.isArray(this.commonObject.scope_upload_links)) {
              this.uploaded_links = this.commonObject.scope_upload_links;
            } else {
              if (this.commonObject.scope_upload_links !== '[]') {
                this.uploaded_links = String(this.commonObject.scope_upload_links).split(',');
              }

            }
          }
        }
      }, err => {
        console.log(err);
      });
    }

     // to convert to common Modal Here
  toConvertToObject(arr) {
    // tslint:disable-next-line:prefer-const
    let common: any = {};
    arr.forEach((item, index) => {
      if (item.answer === 'False') {
        common[item.question_name] = false;
      } else if (item.answer === 'True') {
        common[item.question_name] = true;
      } else if (item.question_name === 'work_other') {
        common[item.question_name] = (item.answer != null) ? JSON.parse(item.answer) : [];
      }else {
        common[item.question_name] = item.answer;
      }
    });
    return common;
  }


 // Editable Option Enable
 callEditableOption() {
  this.isEditable = true;
  this.isuploadImages = true;
  this._globalEvent.sendEnableEditScopeDetails(this.isEditable);
}

// Call the Modal to open
callModaltoOpen() {
  $(this.saveConfirmationModal.nativeElement).modal('show');
}

  // Call Save Button
  callSave() {
    if (this.currentSellerId != null) {
      this.commonObject.seller_id = this.currentSellerId;
      this.commonObject.project_id = this.projectId;
      // tslint:disable-next-line:prefer-const
      let obj1 = Object.assign(this.commonObject, this.commonscopecomponent.commonObject);
      // tslint:disable-next-line:prefer-const
      let finalObj = Object.assign(obj1, this.commondetailscomponent.commonObject);

      this.commonListObject.formtwo.map((item) => {
        if (item.type === 'multiselect') {
          if (this.commondetailscomponent.commonmultiSelect[item.modal] != null &&
            this.commondetailscomponent.commonmultiSelect.hasOwnProperty(item.modal)) {
            finalObj[item.modal] = this.commondetailscomponent.commonmultiSelect[item.modal].map(function (val) {
              return val['name'];
            }).toString();
          }
        }
      });
      this.loadingActive = true;
     // this.commonObject = finalObj;
      this.sellerService.update_serviceRequestBySeller(finalObj, this.commonsafetyboxbrowse.scope_upload_links).finally(() => {
       // this.loadingActive = false;
      }).subscribe(res => {
        this.getQuestionSetByProjectId(this.projectId );
        this.getServiceRequestByprojectId(this.projectId, this.currentUserId);
        $(this.saveConfirmationModal.nativeElement).modal('hide');
        this.isEditable = false;
        this.isuploadImages = false;
        this.loadingActive = false;
        this._globalEvent.sendEnableEditScopeDetails(this.isEditable);
        this._globalEvent.sendEditedInternalName(finalObj.project_internal_name);
      }, err => {
        console.log(err);
        this.loadingActive = false;
      });
    }
  }

  calltoremoveModal() {
    $(this.saveConfirmationModal.nativeElement).modal('hide');
    // this.isVisibleEdit = false;
    this.isEditable = false;
    this._globalEvent.sendEnableEditScopeDetails(this.isEditable);
  }

   // Call Cancel Button
   callCancelOption() {
    this.isEditable = false;
    this.isuploadImages = false;
    this._globalEvent.sendEnableEditScopeDetails(this.isEditable);
  }


  getgeneratedpdf() {

    // tslint:disable-next-line:prefer-const
    let formone = '                <tr>' +
      '                  <td style="width:50%">Projektnamn  <br/><span class="text-secondary">' +
      this.commonObject.project_name + '</span></td>' +
      // tslint:disable-next-line:max-line-length
      '                  <td>Kategori <br/> <span class="text-secondary">' + this.commonObject.service_category_name + '</span></td>' +
      '                </tr>';
    this.commonListObject.formone.map((item) => {
      if (item.type === 'dropdown') {
        formone = formone + '                <tr>' +
        '                  <td style="width:50%">' + item.question + ' <br/><span class="text-secondary">'
        + this.getValues(item.modal, item.value) + '</span></td>' +
        '                  <td>' +
        ' ' + '</td> </tr>' ;
      }

      if (item.type === 'textarea' || item.type === 'address') {
        formone = formone + '                <tr style="width:100%">' +
        '                  <td >' + item.question + ' <br/><span class="text-secondary">'
        + this.getFreetextValueDisplay(this.commonObject[item.modal]) + '</span></td> </tr>';
      }

    });


    // tslint:disable-next-line:prefer-const
    let formtwo1 = '';
    // tslint:disable-next-line:prefer-const
    let formtwo2 = '';
    this.commonListObject.formtwo.map((item, index) => {
      if (index % 2 !== 1) {
        if (item.type === 'dropdown') {
          formtwo1 = formtwo1 + '<tr>' +
            '                  <td>' + item.question + ' <br/><span class="text-secondary">'
            + this.getValues(item.modal, item.value) + '</span></td>' + '</tr>';
        }

        if (item.type === 'text' || item.type === 'inputnumber' ||  item.type === 'yearselector') {
          formtwo1 = formtwo1 + '<tr>' +
            '                  <td >' + item.question + ' <br/><span class="text-secondary">'
            + this.getFreetextValueDisplay(this.commonObject[item.modal]) + '</span></td> </tr>';
        }

        if (item.type === 'multiselect') {
          formtwo1 = formtwo1 + '<tr>' +
            '                  <td >' + item.question + ' <br/><span class="text-secondary">'
            + this.commonObject[item.modal] + '</span></td> </tr>';
        }
      } else {
        if (item.type === 'dropdown') {
          formtwo2 = formtwo2 + '<tr>' +
            '                  <td>' + item.question + ' <br/><span class="text-secondary">'
            + this.getValues(item.modal, item.value) + '</span></td>' + '</tr>';
        }

        if (item.type === 'text' || item.type === 'inputnumber' ||  item.type === 'yearselector') {
          formtwo2 = formtwo2 + '<tr>' +
            '                  <td >' + item.question + ' <br/><span class="text-secondary">'
            + this.getFreetextValueDisplay(this.commonObject[item.modal]) + '</span></td> </tr>';
        }

        if (item.type === 'multiselect') {
          formtwo1 = formtwo1 + '<tr>' +
            '                  <td >' + item.question + ' <br/><span class="text-secondary">'
            +  this.commonObject[item.modal] +  '</span></td> </tr>';
        }
      }

    });

    // tslint:disable-next-line:prefer-const
    let questionset = '';
    this.commonListObject.questionset.map((item, index) => {
      if (this.commonObject[item.modal]) {
        questionset = questionset + '<div class="row">' +
        '                <div class="table-responsive">' +
        '                    <table class="table table-bordered">' +
        '                        <tbody>' +
        '                            <tr>' +
        '                                <td>' +
        item.question +
        '                                </td>' +
        '                            </tr>' +
        '                            <tr>' +
        '                                <td>' +
        '                                   ' +
          this.generatedBody(item) +
        '                                   ' +
        '                                </td>' +
        '                            </tr>' +
        '                        </tbody>' +
        '                    </table>' +
        '                </div>' +
        '            </div>';
      }
    });

    // tslint:disable-next-line:prefer-const <h4>Brief</h4>
    let scopeDetailsPdf = '<!-- section Last <div style="page-break-before:always">  -->' +
      '      <div class="container">' +
      // '        <div class="row mt-5">' +
      // ' </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      formone +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +
      //  work bread down <h4>Work Break Down</h4>
      // '        <div class="row mt-5">' +
      // '  </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered">' +
      '              <tbody>' +
      '                <tr>' +
      '                  <td style="width: 50%">' +
      '            <table class="table">' +
      '              <tbody>' +
      formtwo1 +
      '              </tbody>' +
      '            </table>' +
       '</td>' +
       ' <td style="width: 50%">' +
       '            <table class="table">' +
       '              <tbody>' +
       formtwo2 +
       '              </tbody>' +
       '            </table>' +
      '</td>' +
      '                </tr>' +
      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +
      '     <div class="row"><div class="table-responsive">' +
      '            <table class="table table-bordered" style="width: 100%">' +
      '              <tbody>' +
      questionset +

      '              </tbody>' +
      '            </table>' +
      '          </div>' +
      '    </div>' +
      '        </div>';

    return scopeDetailsPdf;
  }

  // get generated Body
  generatedBody(bodyitem): string {
    // tslint:disable-next-line:prefer-const
    let template = '';
    bodyitem.sub_question_list.map((item, index) => {
      if (bodyitem.sub_question_list.length < 3 || bodyitem.sub_question_list.length === 10) {
        template = template + '<div class="col-11 ml15"> ' +
          '<div class="form-check">' +
          '                        <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
          '                          id="common_details_sb_is_concrete" '
          + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
          '                        <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
          item.question +
          '                        </label>' +
          '                      </div>' +
          this.getsecondLevelBody(item)
          +
          '</div>';
      } else {
        if (index % 2 !== 1) {
          template = template + '<div class="col-6 ml15"> ' +
          '<div class="form-check">' +
          '                        <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
          '                          id="common_details_sb_is_concrete" '
          + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
          '                        <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
          item.question +
          '                        </label>' +
          '                      </div>' +
          this.getsecondLevelBody(item)
          +
          '</div>';
        } else {
          template = template + '<div class="col-5"> ' +
          '<div class="form-check">' +
          '                        <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
          '                          id="common_details_sb_is_concrete" '
          + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
          '                        <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
          item.question +
          '                        </label>' +
          '                      </div>' +
          this.getsecondLevelBody(item)
          +
          '</div>';
        }
      }
    });

    return       '<table class="table">' +
    '              <tbody>' +
    '                <tr>' +
    '                <td style="border:0px !important;">' +
    template +
    '                </td>' +
    '                </tr>' +
    '              </tbody>' +
    '            </table>';

    // return '<div class="card-body">' +
    // '                  <div class="row">' +
    // template +
    // '                  </div>' +
    // '                </div>';
  }

  // Second Level generate
  getsecondLevelBody(bodyitem) {
    // tslint:disable-next-line:prefer-const
    let body = '';
    if (this.commonObject[bodyitem.modal] && Array.isArray(bodyitem.sub_question_list)) {
      bodyitem.sub_question_list.map((item, index) => {
        if (item.type === 'checkbox') {
          body = body + '<div class="col ml40"> ' +
          ' <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
          '                          id="common_details_sb_is_concrete" '
          + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
          ' <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
          item.question +
          '</label>' +
           this.getThirdLevelQuestionSet(item) +
          '</div>';
        } else {
          if (item.type === 'text' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
            body = body + '<div class="ml"> ' +
              '<p>' + this.commonObject[item.modal] + '</p>' +
               this.getThirdLevelQuestionSet(item) +
              '</div>';
          }

          if (item.type === 'inputnumber' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
            body = body + '<div class="ml"> ' +
              '<span class="ml30">' + this.commonObject[item.modal] + '</span>' +
              this.getThirdLevelQuestionSet(item) +
              '</div>';
          }
        }
      });

      // return '<div> ' +
      //         body +
      //   ' </div>';
      if (body !== '') {
        if (bodyitem.sub_question_list.length === 1) {
          return '<table class="table" style="margin-bottom:0px !important;">' +
            '              <tbody>' +
            '                <tr>' +
            '                <td style="border:0px !important;padding:0px !important;">' +
            body +
            '                </td>' +
            '                </tr>' +
            '              </tbody>' +
            '            </table>';
        } else {
          return '<table class="table">' +
            '              <tbody>' +
            '                <tr>' +
            '                <td >' +
            body +
            '                </td>' +
            '                </tr>' +
            '              </tbody>' +
            '            </table>';
        }

      } else {
        return '<div> ' +
          body +
          ' </div>';
      }
    }
    return '';
  }

 getThirdLevelQuestionSet(bodyitem) {
    // tslint:disable-next-line:prefer-const
    let body = '';
    if (this.commonObject[bodyitem.modal] && Array.isArray(bodyitem.sub_question_list)) {
      bodyitem.sub_question_list.map((item, index) => {
        if (item.type === 'text' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
          body = body + '<div class="col-8" >' +
           '<p>' + this.commonObject[item.modal] + '</p>'
           + '</div>';
        } else {
          if (item.type === 'checkbox') {
            body = body + '<div class="col-6"> ' +
            ' <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
            '                          id="common_details_sb_is_concrete" '
            + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
            ' <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
            item.question +
            '</label>' +
            '</div>';
          }

          if (item.type === 'inputnumber' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
            body = body + '<div class="col-6"> ' +
              '<span class="ml30">' + this.commonObject[item.modal] + '</span>'
              + '</div>';
          }
        }

      });
      // return '<div class="row col-12 ml15"> ' + body + ' </div>';
           return '<table class="table">' +
      '              <tbody>' +
      body +
      '              </tbody>' +
      '            </table>';
    }

    return '';
  }

  getFourthLevelBody(bodyitem) {
    // tslint:disable-next-line:prefer-const
    let body = '';
    if (this.commonObject[bodyitem.modal] && Array.isArray(bodyitem.sub_question_list)) {
      bodyitem.sub_question_list.map((item, index) => {
        if (item.type === 'text' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
          body = body + '<div class="col-8" >' +
            '<p>' + this.commonObject[item.modal] + '</p>'
            + '</div>';
        } else {
          if (item.type === 'checkbox') {
            body = body + '<div class="col-6"> ' +
              ' <input class="form-check-input" type="checkbox"  value="true" name="common_details_sb_is_concrete"' +
              '                          id="common_details_sb_is_concrete" '
              + this.getCheckBoxTernary(this.commonObject[item.modal]) + ' >' +
              ' <label class="accordian-checkbox" for="common_details_sb_is_concrete">' +
              item.question +
              '</label>' +
              '</div>';
          }

          if (item.type === 'inputnumber' && (this.commonObject[item.modal] != null || this.commonObject[item.modal] !== undefined)) {
            body = body + '<div class="col-6"> ' +
              '<span class="ml30">' + this.commonObject[item.modal] + '</span>'
              + '</div>';
          }
        }

      });
      return '<div class="col-12"> ' + body + ' </div>';
    }

    return '';
  }



  getCheckBoxTernary(value) {
    if (value) {
      return 'checked';
    } else {
      return '';
    }
  }
  getFreetextValueDisplay(value) {
    if (value != null && value !== undefined) {
      return value;
    } else {
      return '';
    }
  }

    // Remove First Value From Dropdown
    getDropdownList(items: Array<any>, defaultvalue): Array<any> {
      items.map((item, index) => {
        if (item === defaultvalue) {
          items.splice(index, 1);
        }
      });
      return items;
    }

    getValues(position, values) {
      if (this.commonObject[position] != null) {
        return values[Number(this.commonObject[position])];
      }
      return '';
    }


  getDisplayMultiSelect(returnitem: Array<any>) {
    if (returnitem.length > 0) {
      // tslint:disable-next-line:prefer-const
      let value = returnitem.map(function (item) {
        return item['name'];
      });
      return value;
    }
    return '';
  }


}



// WEBPACK FOOTER //
// ./src/app/seller/sub-component/common/common.component.ts